import type { Item, Link } from "./api.ts";
import { itemLinks, type LeaveOut } from "./links.ts";

// An item's links as pills (links.ts says which, and in what words), each opening in a new tab. Quiet wherever they
// show: on a card they're changed under its Files and links' Edit links (CardLinks.tsx).

export function ItemLinks({
  item,
  saved,
  label,
  leaveOut,
}: {
  item: Item;
  saved: Link[];
  label?: string;
  leaveOut?: LeaveOut;
}) {
  const links = itemLinks(item, saved, leaveOut);
  if (links.length === 0) return null;
  return (
    <ul className="tm-contact tm-item-links" aria-label={label ?? `Links for ${item.title}`}>
      {links.map((l) => (
        <li key={l.url} className="tm-item-link-item">
          <a
            className="caption tm-contact-link tm-item-link"
            href={l.url}
            {...(/^https?:/.test(l.url) ? { target: "_blank", rel: "noreferrer noopener" } : {})}
          >
            {l.thumbnail && <img src={l.thumbnail} alt="" className="tm-item-link-thumb" />}
            <span className="tm-item-link-label">{l.label}</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
